import { useOutletContext, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useT, useUI, useLang } from "../lib/i18n";
import SEO from "../components/site/SEO";

export default function About() {
  const { content } = useOutletContext();
  const t = useT();
  const ui = useUI();
  const lang = useLang();
  const about = content.about || {};
  const seo = (content.seo || {}).about;

  return (
    <div data-testid="about-page">
      <SEO seoData={seo} />
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-24 grid md:grid-cols-2 gap-16 items-start">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} className="rounded-3xl overflow-hidden aspect-[4/5] md:sticky md:top-28">
          <img src={about.image_url} alt={t(about.title)} className="w-full h-full object-cover" />
        </motion.div>
        <div>
          <p className="overline mb-4">{t(about.overline) || ui.aboutLabel}</p>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter leading-none font-light">{t(about.title)}</h1>
          <p className="mt-8 text-[#4A3F35] leading-relaxed text-lg">{t(about.description)}</p>
          {t(about.long_description) && (<p className="mt-6 text-[#4A3F35] leading-relaxed whitespace-pre-line">{t(about.long_description)}</p>)}
          <div className="mt-10"><Link to={`/${lang}/contact`} className="btn-primary">{ui.workTogether} <ArrowRight size={16} /></Link></div>
        </div>
      </section>
    </div>
  );
}
